import React, { useEffect, useState } from 'react';
import { Card, List, Tag, Button, Popconfirm, message, Empty, Spin, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import { useUser } from '../context/UserContext';
import api from '../api/client';

export default function Subscription() {
  const { user }  = useUser();
  const [subs, setSubs]     = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const r = await api.get(`/api/users/${user.userId}/subscriptions`); setSubs(r.data); }
    catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { if (user?.userId) load(); }, [user?.userId]);

  const cancel = async (id) => {
    try {
      await api.patch(`/api/subscriptions/${id}/cancel`);
      message.success('Subscription cancelled');
      load();
    } catch { message.error('Failed to cancel'); }
  };

  return (
    <AppLayout>
      <div className="page-header">
        <h1>Subscriptions</h1>
        <p>
          {user.role === 'student'
            ? 'Tutors you are currently subscribed to.'
            : 'Students subscribed to your tutoring.'}
        </p>
      </div>

      {loading
        ? <div style={{ textAlign: 'center', padding: 60 }}><Spin /></div>
        : subs.length === 0
          ? <Empty description="No active subscriptions." style={{ padding: 80 }} />
          : (
            <List
              grid={{ gutter: 16, xs: 1, sm: 2, md: 3 }}
              dataSource={subs}
              renderItem={sub => (
                <List.Item>
                  <Card variant="outlined" style={{ borderColor: '#e8e8e8' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                      <Avatar
                        size={40}
                        src={user.role === 'student' ? sub.tutor_avatar : sub.student_avatar}
                        icon={<UserOutlined />}
                        style={{ background: '#0a0a0a', flexShrink: 0 }}
                      />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13 }}>
                          {user.role === 'student' ? sub.tutor_name : sub.student_name}
                        </div>
                        {sub.subject_name && (
                          <div style={{ fontSize: 12, color: '#555', marginTop: 1 }}>
                            {sub.subject_name}{sub.subject_level ? ` · ${sub.subject_level}` : ''}
                          </div>
                        )}
                        <Tag color="success" style={{ fontSize: 11, marginTop: 2 }}>Active</Tag>
                      </div>
                    </div>

                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                      <span style={{ color: '#888' }}>From</span> {sub.start_date_fmt}
                      {sub.end_date_fmt && <> <span style={{ color: '#888' }}>to</span> {sub.end_date_fmt}</>}
                    </div>
                    {sub.monthly_rate && (
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#0a0a0a', marginBottom: 16 }}>
                        ${parseFloat(sub.monthly_rate).toFixed(2)} / month
                      </div>
                    )}

                    {user.role === 'student' && (
                      <Popconfirm title="Cancel this subscription?" onConfirm={() => cancel(sub.subscription_id)}>
                        <Button size="small" danger block>Cancel subscription</Button>
                      </Popconfirm>
                    )}
                  </Card>
                </List.Item>
              )}
            />
          )
      }
    </AppLayout>
  );
}